export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/79f57583353282fe19c28e67d8b0efb1.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <h1 className="text-7xl font-extralight text-white mb-8 tracking-wide leading-tight">
          CRAFTING PREMIUM<br />iOS EXPERIENCES
        </h1>
        <p className="text-xl text-white/85 font-light max-w-2xl mx-auto leading-relaxed">
          Expert team developing VPN and Cleaner solutions for enhanced mobile security and performance
        </p>
      </div>

      {/* Bottom Accent */}
      <div className="absolute bottom-0 left-0 right-0 h-1/4 flex items-end justify-center pb-12 pointer-events-none">
        <div className="text-8xl font-bold text-white/15 tracking-widest">
          INNOVATION • SECURITY • PERFORMANCE
        </div>
      </div>
    </section>
  );
}
